import React from "react";

const OptionsContext = React.createContext({});
OptionsContext.displayName = "OptionsContext";

export default OptionsContext;
